import { Helmet } from 'react-helmet-async';
import { filter } from 'lodash';
import { sentenceCase } from 'change-case';
import { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import axios from 'axios';
// @mui
import {
  Card,
  Table,
  Stack,
  Paper,
  Avatar,
  Button,
  Popover,
  Checkbox,
  TableRow,
  MenuItem,
  TableBody,
  TableCell,
  Container,
  Typography,
  IconButton,
  TableContainer,
  TablePagination,
} from '@mui/material';
// components
import Label from '../components/label';
import Iconify from '../components/iconify';
import Scrollbar from '../components/scrollbar';
// sections
import { UserListHead, UserListToolbar } from '../sections/@dashboard/user';
import DevicesPage from './DevicesPage';
import HunterForRifle from '../components/HunterForRifle';
// ----------------------------------------------------------------------
const styles = { 
  narrowCell: {
    'width': '150px',
  }
};

const TABLE_HEAD = [
  { id: 'marka', label: 'Marka', alignRight: false },
  { id: 'kalibar', label: 'Kalibar', alignRight: false },
  { id: 'serijskibroj', label: 'Serijski broj', alignRight: false },
  { id: 'oruznilist', label: 'Oruzni list', alignRight: false },
  { id: 'mup', label: 'MUP', alignRight: false }
];

// ----------------------------------------------------------------------

function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function getComparator(order, orderBy) {
  return order === 'desc'
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

function applySortFilter(array, comparator, query) {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  if (query) {
    return filter(array, (_user) => _user.ime.toLowerCase().indexOf(query.toLowerCase()) !== -1);
  }
  return stabilizedThis.map((el) => el[0]);
}

export default function ClanOruzje(props) {

  const navigate  = useNavigate();	
	
  const [open, setOpen] = useState(null);

  const [page, setPage] = useState(0);

  const [order, setOrder] = useState('asc');
  
  const [members, setMembers] = useState([]);
  
  const [id, setId] = useState(0);
  
  const [dataloaded, setDataLoaded] = useState(false);

  const [selected, setSelected] = useState([]);

  const [orderBy, setOrderBy] = useState('id');

  const [filterName, setFilterName] = useState('');

  const [rowsPerPage, setRowsPerPage] = useState(10);
  
  const [showriflecreate, setShowRifleCreate] = useState(false);
  
  const SERVER_URL = process.env.REACT_APP_BACKEND_SERVER_URL;
  
  const handleRefresh = (event, id) => {  
	setShowRifleCreate(!showriflecreate);
	refreshData();
  };
  
  useEffect(() => {    // Update the document title using the browser API    
  });
  
  function refreshData() {
	  
  console.log(props.vlasnik);  
  const str1 = SERVER_URL + "/rifles?hunterId=";
  const str2 = str1.concat('', props.vlasnik);
  const url = str2;
  console.log(url);
		
    fetch(url)
      .then((res) => res.json())
      .then((json) => {
		setId(props.vlasnik);
        setMembers(json);
		setDataLoaded(true);
        console.log(json);
    });
  }
  
  if (id !== props.vlasnik)
	refreshData();

  const Delete = (data) => {
  console.log(data);  
  const str1 = SERVER_URL + "/rifles/";
  const str2 = str1.concat('', data);
  const url = str2;
  console.log(url);
		
		axios.delete(url)
		.then(() => {
            navigate('/dashboard/HuntersReportAll')
			refreshData();
        })
  }

  const setData = (data) => {
  console.log(data);
  localStorage.setItem('hunterId', data);
  }
  
  const handleOpenMenu = (event) => {
    setOpen(event.currentTarget);
  };

  const handleCloseMenu = () => {
    setOpen(null);
  };

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const newSelecteds = members.map((n) => n.ime);
      setSelected(newSelecteds);
      return;
    }
    setSelected([]);
  };

  const handleClick = (event, ime) => {
    const selectedIndex = selected.indexOf(ime);
    let newSelected = [];
    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, ime);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(selected.slice(0, selectedIndex), selected.slice(selectedIndex + 1));
    }
    setSelected(newSelected);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setPage(0);
    setRowsPerPage(parseInt(event.target.value, 10));
  };

  const handleFilterByName = (event) => {
    setPage(0);
    setFilterName(event.target.value);
  };

  const emptyRows = page > 0 ? Math.max(0, (1 + page) * rowsPerPage - members.length) : 0;

  const filteredUsers = applySortFilter(members, getComparator(order, orderBy), filterName);

  const isNotFound = !filteredUsers.length && !!filterName;

  return (
    <>
      <Helmet>
        <title>  GPS Dogs Tracking System </title>
      </Helmet>

      <Container maxWidth="xl"> 
	  
	  <Button onClick={() => setShowRifleCreate(!showriflecreate)}>Add Oružje</Button>	
	  {showriflecreate && <HunterForRifle hunterId = {props.vlasnik} handler = {handleRefresh} className = "child"/>}	
	  
        <Card>
		Oružje

		  {members.length > 0 ? <Scrollbar>
            <TableContainer sx={{ minWidth: 800 }}>
              <Table style={{ tableLayout: 'fixed' }}>
                <UserListHead
				  color='#002884'
                  order={order}
                  orderBy={orderBy}
                  headLabel={TABLE_HEAD}
                  rowCount={members.length}
                  numSelected={selected.length}
                  onRequestSort={handleRequestSort}
                  onSelectAllClick={handleSelectAllClick}
                />
                <TableBody>
                  {members.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((row) => {
                    const { id, marka, kalibar, serijskibroj, oruznilist, mup, photo } = row; 
					
                    const selectedUser = selected.indexOf(marka) !== -1;

                    return (
                      <TableRow hover key={id}>
 
                        <TableCell component="th" scope="row" padding="10px" style={{width: "350px"}}>
                          <Stack direction="row" alignItems="center" spacing={2}>
                            <Avatar alt={marka} src={photo}/>
                          </Stack>
                        </TableCell>
						
						<TableCell align="left">
						<Typography variant="subtitle2" noWrap>
						{marka}
						</Typography>
						</TableCell>
						
					    <TableCell align="left">
						<Typography variant="subtitle2" noWrap>
						{kalibar}
						</Typography>
						</TableCell>
						
						<TableCell align="left">
						<Typography variant="subtitle2" noWrap>
						{serijskibroj}
						</Typography>
						</TableCell>

                        <TableCell align="left">
						<Typography variant="subtitle2" noWrap>
						{oruznilist}
						</Typography>
						</TableCell>
						
						<TableCell align="left">
						<Typography variant="subtitle2" noWrap>
						{mup}
						</Typography>
						</TableCell>
						
						<TableCell align="left">
						<Button onClick={() => Delete(id)}>Delete({id})</Button>	
						</TableCell>
						
                      </TableRow>
                    );
                  })}
                  {emptyRows > 0 && (
                    <TableRow style={{ height: 53 * emptyRows }}>
                      <TableCell colSpan={6} />
                    </TableRow>
                  )}
                </TableBody>

                {isNotFound && (
                  <TableBody>
                    <TableRow>
                      <TableCell align="center" colSpan={6} sx={{ py: 3 }}>
                        <Paper
                          sx={{
                            textAlign: 'center',
                          }}
                        >
                          <Typography variant="h6" paragraph>
                            Not found
                          </Typography>

                          <Typography variant="body2">
                            No results found for &nbsp;
                            <strong>&quot;{filterName}&quot;</strong>.
                            <br /> Try checking for typos or using complete words.
                          </Typography>
                        </Paper>
                      </TableCell>
                    </TableRow>
                  </TableBody>
                )}
              </Table>
            </TableContainer>
			</Scrollbar> 
		    : <div><br /> Nema oruzje </div>}
			
        </Card>
      </Container>

      <Popover
        open={Boolean(open)}
        anchorEl={open}
        onClose={handleCloseMenu}
        anchorOrigin={{ vertical: 'top', horizontal: 'left' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
        PaperProps={{
          sx: {
            p: 1,
            width: 140,
            '& .MuiMenuItem-root': {
              px: 1,
              typography: 'body2',
              borderRadius: 0.75,
            },
          },
        }}
      >
        <MenuItem>
          <Iconify icon={'eva:edit-fill'} sx={{ mr: 2 }} />
          Edit
        </MenuItem>

        <MenuItem sx={{ color: 'error.main' }}>
          <Iconify icon={'eva:trash-2-outline'} sx={{ mr: 2 }} />
          Delete
        </MenuItem>
      </Popover>
    </>
  );
}
